import React from 'react';
import styled from 'styled-components';
import { themeColor } from '../../Theming';
import { nationalRailImages } from '../../Theming/images';

const PanelContainer = styled.div`
  position: relative;
  width: 100%;
  background-color: ${themeColor('lightBlueGrey')};
  padding: 30px 20px 30px 20px;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;

  @media (min-width: 2560px) {
    padding-top: 60px;
  }

  @media (min-height: 950px) {
    justify-content: center;
  }
`;

const PanelHeader = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const NationalRailLogo = styled.img`
  max-width: 200px;
  height: auto;
  margin-bottom: 25px;
`;

const HeaderText = styled.div`
  text-align: center;
  color: white;
`;

const BoldText = styled.p`
  font-weight: 700;
  font-size: 28px;
  font-family: 'Century Gothic', sans-serif;
  margin: 0;
`;

export const RegularText = styled.p`
  font-weight: 300;
  font-size: 24px;
  font-family: 'Century Gothic', sans-serif;
  margin: 0;
`;

export const Divider = styled.div<{ borderColorName: string }>`
  width: 200px;
  height: 0px;
  border: 3px solid
    ${(props) =>
      props.theme.colors[
        props.borderColorName as keyof typeof props.theme.colors
      ]};
  opacity: 1;
  margin: 20px 0;
`;

const PoweredByLogo = styled.img`
  max-width: 206px;
  height: auto;
  margin: 0;
`;

const ContentArea = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  margin-top: 10px;
`;

interface ContentPanelProps {
  children: React.ReactNode;
}

const PanelWrapper = styled.div`
  position: absolute;
  left: 60px;
  top: 50px;
  width: 460px;
  z-index: 10;
  padding-bottom: 50px;
  max-height: calc(100vh - 100px);

  @media (min-width: 2560px) {
    left: 6vw;
    width: 22vw;
    max-width: 600px;
  }

  @media (min-height: 950px) {
    top: 50%;
    padding-bottom: 0;
    transform: translateY(-50%);
    max-height: 90vh;
  }
`;

const ContentPanel: React.FC<ContentPanelProps> = ({ children }) => {
  return (
    <PanelWrapper>
      <PanelContainer>
        <PanelHeader>
          <NationalRailLogo
            src={nationalRailImages.nationalRailLogo.default}
            alt="National Rail Logo"
          />
          <HeaderText>
            <BoldText>Ride and Shop</BoldText>
            <RegularText>Smart shopping while you travel.</RegularText>
          </HeaderText>
          <Divider borderColorName="navy" />
          <PoweredByLogo
            src={nationalRailImages.poweredByKindred.default}
            alt="Powered by Kindred"
          />
          <Divider borderColorName="gold" />
        </PanelHeader>
        <ContentArea>{children}</ContentArea>
      </PanelContainer>
    </PanelWrapper>
  );
};

export default ContentPanel;
